import { initializeApp } from 'firebase/app';

export const firebaseConfig = {
  apiKey: "AIzaSyDQZY_-Kg2ZgLWvxLMr06N7lJS8u9XcSUw",
  authDomain: "duna-545e1.firebaseapp.com",
  projectId: "duna-545e1",
  storageBucket: "duna-545e1.appspot.com",
  messagingSenderId: "356645221338",
  appId: "1:356645221338:web:113aaa2cffb5e0af8606e3",
  measurementId: "G-3YG2Y1XQ0Y",
  vapidKey: "BCqGJ31lWAJUXNNUJkOt2ZC-OpolFI79l2tFx-i9MZixnnRB1kf8WagTDCCNd14tkAjDlqpJTsL_-z2ObenTPU8"
};

export const firebaseApp = initializeApp(firebaseConfig);

